import React from  'react'
import { graphql } from 'gatsby'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

import PostLayout from '../components/posts'
import Head from '../components/head'
import "../styles/components/postLayout.module.scss"


export const query = graphql`
  query ($slug: String!){
    contentfulBlogPost(
      slug:{eq: $slug}) {
        myTitle
        publishedDate(formatString:"MMMM Do, YYYY")
        body {
          json
        }
      }
  }
`
const BlogPage = props => {
  const options = {
    renderNode: {
      "embedded-asset-block": (node) => {
        const alt = node.data.target.fields.title['en-US']
        const url = node.data.target.fields.file['en-US'].url
        return <img alt={alt} src={url} />
      }
    }
  }

   return (
       <PostLayout>
          <Head title={props.data.contentfulBlogPost.myTitle}/>
              <article className="postText">
                  <h1>{props.data.contentfulBlogPost.myTitle}</h1>
                    <h2>{props.data.contentfulBlogPost.publishedDate}</h2>
                      {documentToReactComponents(props.data.contentfulBlogPost.body.json, options)}
              </article>
       </PostLayout>
   )
}

export default BlogPage
